<template>
  <path
    d="M12 2.00024C6.48 2.00024 2 6.48024 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48024 17.52 2.00024 12 2.00024ZM11.65 14.6502L8.86 11.8602C8.54 11.5402 8.76 11.0002 9.21 11.0002H14.8C15.25 11.0002 15.47 11.5402 15.15 11.8502L12.36 14.6402C12.16 14.8402 11.84 14.8402 11.65 14.6502Z"
  />
</template>
